export default "__VITE_ASSET__DOEiGTml__"